import { Box } from '@mui/material';
import CircularProgress, {
    CircularProgressProps,
} from '@mui/material/CircularProgress';

/**
 * wrapper of @mui's CircularProgress component
 * @note need to extend api to include fullscreen functionality.
 *  - fullscreen
 */
export function LoadingSpinner(props?: CircularProgressProps) {
    return (
        <Box>
            <CircularProgress data-testid="loading-spinner" {...props} />
        </Box>
    );
}
